import styled from 'styled-components'

const textPrimary = p => p.theme.colors.text.primaryText
const textSecondary = p => p.theme.colors.text.secondaryText
const brandBlue = p => p.theme.colors.brand.blueOmint
const branDarkdBlue = p => p.theme.colors.brand.blueDark
const disabledGrey = p => p.theme.colors.greys.disabledGrey

export const Stack = styled.div`
	display: flex;
	flex-direction: ${({ direction }) => direction || 'column'};
	align-items: ${({ align }) =>
		align === 'start'
			? 'flex-start'
			: align === 'end'
				? 'flex-end'
				: align === 'stretch'
					? 'stretch'
					: 'center'};
	justify-content: ${({ justify }) =>
		justify === 'start'
			? 'flex-start'
			: justify === 'end'
				? 'flex-end'
				: justify === 'between'
					? 'space-between'
					: justify === 'around'
						? 'space-around'
						: 'center'};
	gap: ${({ gap }) => gap ? gap : 16}px;
	flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
	width: ${({ width }) => width || '100%'};
	max-width: ${({ maxWidth }) => maxWidth || 'none'};
	margin: ${({ margin }) => margin || '0'};
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
	padding: ${({ padding }) => padding || '0'};
`

export const Wrapper = styled.div`
	@media (max-width: ${({ theme }) => theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: column;
	}
`

export const FormContainer = styled(Stack).attrs(({ align = 'center', ...rest }) => ({
	direction: 'column',
	align,
	width: '100%',
	...rest
}))`
	max-width: ${({ maxWidth }) => maxWidth || '359px'};
	margin: ${({ margin }) => margin || '0 auto'};
	padding: ${({ padding }) => padding || '0'};
	display: flex;
	flex-direction: ${({ direction }) => direction || 'column'};
	justify-content: ${({ justify }) =>
		justify === 'start'
			? 'flex-start'
			: justify === 'end'
				? 'flex-end'
				: justify === 'between'
					? 'space-between'
					: justify === 'around'
						? 'space-around'
						: 'center'};
	@media (max-width: ${({ theme }) => theme.sizes.breakPoints.small}) {
		width: 100%;
		max-width: ${({ maxWidth }) => maxWidth || '800px'};
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: ${({ justifyMobile }) =>
		justifyMobile === 'start'
			? 'flex-start'
			: justifyMobile === 'end'
				? 'flex-end'
				: justifyMobile === 'between'
					? 'space-between'
					: justifyMobile === 'around'
						? 'space-around'
						: 'center'};
		padding: ${({ paddingMobile }) => paddingMobile || '0px 20px'};
	}
`

export const FormSection = styled(Stack).attrs({
	direction: 'column',
	width: '100%',
	align: 'start',
})`
  gap: ${({ gap }) => gap || 16}px;
  padding: ${({ padding }) => padding || '0'};
  margin-bottom: ${({ mb }) => mb || 0}px;
`


export const BackButton = styled(Stack).attrs({
	direction: 'row',
	align: 'center',
	justify: 'start',
	width: '100%',
	gap: 8
})`
	cursor: pointer;
`

export const FormHeader = styled(Stack).attrs({
	direction: 'column',
	width: '100%'
})``

export const FormTitle = styled.h1`
	font-size: ${({ font }) => (font ? `${font}px` : '32px')};
	font-weight: 700;
	color: ${textPrimary};
	text-align: ${({ align }) => align || 'center'};
	margin: 0;
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
`
export const FormSubtitleBold = styled.p`
	font-size: ${({ font }) => (font ? `${font}px` : '18px')};
	font-weight: 600;
	color: ${textPrimary};
	text-align: ${({ align }) => align || 'center'};
	margin: 0;
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
`

export const FormSubtitle = styled.p`
	font-size: ${({ font }) => (font ? `${font}px` : '16px')};
	font-weight: 400;
	color: ${textSecondary};
	text-align: ${({ align }) => align || 'center'};
	margin: 0;
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
`

export const FormText = styled.p`
	font-size: ${({ font }) => (font ? `${font}px` : '14px')};
	font-weight: ${({ fw }) => fw ?? 400};
	line-height: ${({ $lh }) => $lh ?? 1.5};
	color: ${({ color }) => color || textPrimary};
	text-align: ${({ align }) => align || 'center'};
	margin: 0;
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
`

export const ClinicLogoContainer = styled(Stack).attrs({
	direction: 'row',
	justify: 'center',
	align: 'center',
	wrap: true,
	width: '100%'
})`
	display: grid;
	grid-template-columns: repeat(6, minmax(0, 1fr));
	justify-items: center;
	align-items: center;
	column-gap: clamp(4px, 1vw, 12px);
	row-gap: 8px;
`

export const ClinicLogo = styled.img`
	width: 60px;
	height: 60px;
	border-radius: 50%;
	object-fit: cover;
`

export const InputsContainer = styled(Stack).attrs({
	display: 'flex',
	direction: 'column',
	width: '100%'
})`
	flex: ${({ flex }) => flex || 1};
	height: ${({ height }) => height || '100%'};

	@media (max-width: ${p => p.theme.sizes.breakPoints.small}) {
		${({ heightMobile }) => heightMobile && `height: ${heightMobile};`}
		justify-content: flex-start;
	}

`

export const LinkButton = styled.button`
	background: none;
	border: none;
	color: ${brandBlue};
	font-size: 16px;
	cursor: pointer;
	padding: 0;
	text-decoration: underline;
	align-self: ${({ alignSelf }) => alignSelf || 'center'};
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
	font-weight: 600;
	&:hover {
		color: ${branDarkdBlue};
	}
`

export const LinkButtonFrontPage = styled.button`
	background: none;
	border: none;
	color: ${brandBlue};
	font-size: 14px;
	cursor: pointer;
	padding: 0;
	align-self: ${({ alignSelf }) => alignSelf || 'center'};
	margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
	&:hover {
		color: ${branDarkdBlue};
	}
`

export const ButtonsContainer = styled(Stack).attrs({
	direction: 'column',
	width: '100%'
})``

export const SecondaryButtonsContainer = styled(Stack).attrs({
	direction: 'column',
	width: '100%'
})``

export const FooterText = styled.p`
	display: flex;
	gap: 8px;
	font-size: 0.875rem;
	color: ${textPrimary};
	text-align: center;
	margin: 0;
`
export const HeaderDesktop = styled.div`
	display: none;
	@media (min-width: ${p => p.theme.sizes.breakPoints.small || '768px'}) {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 32px;
	}
`

export const HeaderMobile = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 32px;
	@media (min-width: ${p => p.theme.sizes.breakPoints.small || '768px'}) {
		display: none;
	}
`

export const MobileBackButton = styled.button`
	background: none;
	border: none;
	padding: 8px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;

	svg {
		width: 16px;
		height: 16px;
		transform: rotate(0deg);
		color: ${p => p.theme.colors.grey || '#666'};
	}

	&:hover {
		opacity: 0.7;
	}
`

export const EmptySpace = styled.div`
	flex: 0 0 auto;
	width: 40px;
`

export const TextSteap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const FormContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 32px;
	@media (max-width: ${p => p.theme.sizes.breakPoints.small || '768px'}) {
		height: 100%;
		display: flex;
		flex: 1;
		justify-content: space-between;
	}
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ color, theme }) => color ? color : theme.colors.greys.disabledGrey || '#666'};
  margin: ${({ margin }) => (margin ? `${margin}` : 0)};
`;